/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LicenseType } from '../../models/license-type';
import { LicenseTypeApiRespModel } from '../../models/license-type-api-resp-model';

export interface ApiMasterLicenseTypeAddPost$Params {
      body?: LicenseType
}

export function apiMasterLicenseTypeAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterLicenseTypeAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LicenseTypeApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterLicenseTypeAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LicenseTypeApiRespModel>;
    })
  );
}

apiMasterLicenseTypeAddPost.PATH = '/api/Master/LicenseType/Add';
